import http from './../../../../../core/services/http.service';

export default {
  getLinks(params = null) {
    return http.get('/api/v1/customers/links/', {params});
  },
  getLink(id, params = {}) {
    return http.get(`/api/v1/customers/links/${id}/`, {params});
  },
  updateLink(id, data) {
    return http.put(`/api/v1/customers/links/${id}/`, data);
  },
  createLink(data) {
    return http.post('/api/v1/customers/links/', data);
  },
  createOrUpdateLink(data) {
    if (data.uuid) {
      return this.updateLink(data.uuid, data);
    }
    return this.createLink(data);
  },
  removeLink(uuid) {
    return http.delete(`/api/v1/customers/links/${uuid}/`)
  }
};
